<template>
  <div class="item-remove">
    <button type="button" class="item-remove__button" @click="remove">Remove</button>
  </div>
</template>

<script lang="ts" setup>
import { useCartInject } from '../../context/useCartContext'
import { LiquidLineItem } from '../../types/liquid'

const { cart, removeLineItems } = useCartInject()

const props = defineProps<{
  line: LiquidLineItem
}>()

const remove = async () => {
  const itemsToRemove = [{ id: props.line.key }]

  const additions = cart.value.items.filter(
    (item) => item.properties?.Product === props.line.product_title
  )

  additions.forEach((item) => {
    itemsToRemove.push({
      id: item.key,
    })
  })

  await removeLineItems(itemsToRemove)
}
</script>

<style lang="scss">
@import '~styles/base';

.item-remove {
  padding-top: 15px;
  cursor: pointer;

  > * {
    /* @include animate-underline; */
    text-decoration: underline;

    @include hover {
      text-decoration: none;
    }
  }
}
</style>
